// extracted by mini-css-extract-plugin
module.exports = {"section":"ExpressionsTab_section__HsVgt","expressionsHeader":"ExpressionsTab_expressionsHeader__3iy5x","expressionsActionsBtns":"ExpressionsTab_expressionsActionsBtns__1VrtQ"};